import request from "@/utils/request.js";
// 获取子账号列表
export const getChildAccount = params => {
  return request({
    method: "get",
    url: "/sublevel/list",
    params
  });
};

// 创建子账号
export const addChildAccount = data => {
  return request({
    method: "post",
    url: "/sublevel/store",
    data
  });
};

// 编辑子账号
export const editChildAccount = data => {
  return request({
    method: "post",
    url: "/sublevel/modify",
    data
  });
};

// 获取子账号名称
export const getChildAccountName = () => {
  return request({
    method: "get",
    url: "/sublevel/name"
  });
};

// 获取子账号项目列表
export function getChildAssessList(params) {
  return request({
    method: "get",
    url: "/sublevel/project",
    params
  });
}
